/* MaisonVera article photos. Plain image links remain the fallback. */
(() => {
  'use strict';
  if (window.MaisonVeraBlogPhotos) {
    window.MaisonVeraBlogPhotos.init(document);
    return;
  }

  const registeredDialogs = new WeakSet();
  const registeredLinks = new WeakMap();
  let opener = null;

  function imageFor(link) {
    try {
      const url = new URL(link.dataset.mvBlogZoomSrc, window.location.href);
      const width = Number(link.dataset.mvBlogZoomWidth);
      const height = Number(link.dataset.mvBlogZoomHeight);
      if (link.tagName !== 'A' || url.href !== new URL(link.href, window.location.href).href ||
          url.protocol !== 'https:' || url.username || url.password || url.port || url.hash ||
          !['maisonvera.be', 'cdn.shopify.com', 'het-prijzenpaleis.myshopify.com'].includes(url.hostname) ||
          !/^\/(?:cdn\/shop\/|s\/files\/)/.test(url.pathname) ||
          !/\.(?:jpe?g|png|webp|avif)$/i.test(url.pathname) ||
          ![...url.searchParams.keys()].every(key => ['v', 'width', 'height', 'quality', 'format'].includes(key)) ||
          !Number.isInteger(width) || !Number.isInteger(height) || width < 2 || height < 2 || width > 20000 || height > 20000) return null;
      return Object.freeze({src: url.href, width, height, alt: link.dataset.mvBlogZoomAlt || ''});
    } catch {
      return null;
    }
  }

  function init(scope = document) {
    const dialog = document.getElementById('MaisonVeraBlogImageDialog');
    if (!dialog || typeof dialog.showModal !== 'function' || typeof dialog.close !== 'function') return;
    const photo = dialog.querySelector('[data-mv-blog-photo]');
    const close = dialog.querySelector('[data-mv-blog-close]');
    const toggle = dialog.querySelector('[data-mv-blog-native]');
    const viewport = dialog.querySelector('[data-mv-blog-viewport]');
    if (!photo || !close || !toggle || !viewport) return;

    function reset() {
      viewport.classList.remove('is-native');
      toggle.setAttribute('aria-pressed', 'false');
      toggle.textContent = toggle.dataset.nativeLabel;
    }

    if (!registeredDialogs.has(dialog)) {
      dialog.hidden = false;
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('cancel', event => { event.preventDefault(); dialog.close(); });
      dialog.addEventListener('close', () => {
        reset();
        photo.removeAttribute('src');
        photo.removeAttribute('width');
        photo.removeAttribute('height');
        photo.alt = '';
        if (opener?.isConnected) opener.focus();
        opener = null;
      });
      toggle.addEventListener('click', () => {
        const native = toggle.getAttribute('aria-pressed') !== 'true';
        viewport.classList.toggle('is-native', native);
        toggle.setAttribute('aria-pressed', String(native));
        toggle.textContent = native ? toggle.dataset.fitLabel : toggle.dataset.nativeLabel;
        viewport.scrollTop = viewport.scrollLeft = 0;
        viewport.focus();
      });
      registeredDialogs.add(dialog);
    }

    scope.querySelectorAll('a.mv-blog-photo-zoom[data-mv-blog-zoom-src]').forEach(link => {
      if (registeredLinks.has(link)) return;
      const image = imageFor(link);
      if (!image) return;
      registeredLinks.set(link, image);
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', dialog.id);
      if (link.dataset.mvBlogZoomLabel) link.setAttribute('aria-label', link.dataset.mvBlogZoomLabel);
      link.addEventListener('click', event => {
        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
            (event.button !== undefined && event.button !== 0)) return;
        reset();
        photo.src = image.src;
        photo.width = image.width;
        photo.height = image.height;
        photo.alt = image.alt;
        try {
          if (!dialog.open) dialog.showModal();
        } catch {
          photo.removeAttribute('src');
          return; // Keep ordinary HTTPS navigation when a dialog cannot open.
        }
        event.preventDefault();
        opener = link;
        close.focus();
        viewport.scrollTop = viewport.scrollLeft = 0;
      });
    });
  }

  window.MaisonVeraBlogPhotos = {init};
  document.addEventListener('shopify:section:load', event => init(event.target));
  init(document);
})();
